import Checkbox from '@components/Checkbox';
import CheckboxLI from '@components/CheckboxLI';
import Column from '@components/Column';
import Text from '@components/Text';
import { useFlow } from '@router/stackflow';

import useAgreement from './hooks/useAgreement';
import styles from './styles.module.scss';

function Agreements() {
  const {
    isAllChecked, agreeAll,
    termCategories, toggleTermCategory, isChecked,
  } = useAgreement();
  const { push } = useFlow();
  return (
        <Column as='section' className={styles.container}
                spacing={12}
                fullWidth >
            <Text size='xl' fontWeight='bold'>
                서비스 이용 법률
            </Text>
            <Column spacing={6} fullWidth>
                <div className={styles.all}>
                    <Checkbox isChecked={isAllChecked}
                              onClick={agreeAll} >
                        모두 동의할게요
                    </Checkbox>
                </div>
                {termCategories.map((termCategory) => (
                    <CheckboxLI isChecked={isChecked(termCategory.id)}
                                key={termCategory.id}
                                required={termCategory.isRequired}
                                onClick={() => push('TermDetailActivity', { termCategoryId: termCategory.id })}
                                toggleCheckbox={() => toggleTermCategory(termCategory.id)}>
                        {termCategory.title}
                    </CheckboxLI>
                ))}
            </Column>
        </Column>
  );
}

export default Agreements;
